import { TreatmentFilter } from '@src/app/features/search/models/treatment-filter.model';
import { formStatusToTreatmentStatusMap } from '@src/app/features/search/search.utils';
import { FormStatus } from '@shared/enums/form-status.enum';

export function getSpeechAssessmentFilters(): TreatmentFilter[] {
  return [
    {
      treatmentType: {
        value: 0,
        label: 'treatment.speech'
      },
      children: [
        {
          treatmentType: {
            value: 'speechAssessmentTypeStates',
            label: 'treatment.speech_assessment'
          },
          treatmentStatuses: [
            formStatusToTreatmentStatusMap.get(FormStatus.SUBMITTED),
            formStatusToTreatmentStatusMap.get(FormStatus.IN_PROGRESS),
            formStatusToTreatmentStatusMap.get(FormStatus.REJECTED)
          ]
        }
      ]
    }
  ];
}
